import { options } from "@/store/options";
import headerHeights from "@/assets/styles/_variables.scss";

export const getTranslateX = element => {
  const style = window.getComputedStyle(element);
  const { m41 = "" } =
    typeof window !== "undefined" &&
    /* eslint-disable-next-line */
    new WebKitCSSMatrix(style.webkitTransform);
  return m41;
};

export const addSpacesToNumber = number => {
  return number
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    : "N/A";
};

export const isString = element => {
  return typeof element === "string";
};

export const getFloorToHundreds = number => {
  return Math.floor(number / 100) * 100;
};

export const getCeilToHundreds = number => {
  return Math.ceil(number / 100) * 100;
};

export const removeSpaces = element => {
  return element ? element.split(" ").join("") : "";
};

export const formatDateForApi = date => {
  const currentMonth = date.getMonth() + 1;
  const currentDay = date.getDate();

  const year = date.getFullYear();
  const month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
  const day = currentDay < 10 ? `0${currentDay}` : currentDay;

  return `${year}-${month}-${day}`;
};

export const capitalize = element => {
  return element.charAt(0).toUpperCase() + element.slice(1);
};

export const formatCurrency = (number, separator = ",") => {
  return number
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    : "";
};

export const filterById = ({ map, arrayWithCodes, id }) => {
  return map.filter(item => {
    return arrayWithCodes.includes(item[id]);
  });
};

export const roundUp = ({ number, decimalPlaces = 0 }) => {
  return (Math.ceil(number * 100) / 100).toFixed(decimalPlaces);
};

export const moveTo = (elem, smooth = false) => {
  const element = document.getElementById(elem);
  element.scrollIntoView({ behavior: smooth ? "smooth" : "auto" });

  if (!smooth) {
    const headerHeight = options.isMobile
      ? headerHeights.mobileHeaderHeight
      : headerHeights.desktopHeaderHeight;

    window.scrollBy(0, -headerHeight);
  }
};

export const formatDaySuffix = day => {
  if (day > 3 && day < 21) return `${day}th`;

  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

export const getFormattedPresentDate = () => {
  const todayDate = new Date()
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit"
    })
    .split(" ");

  todayDate[0] = formatDaySuffix(todayDate[0]);

  return todayDate.join(" ");
};

export const isObject = value => value === Object(value);
